import { render, staticRenderFns } from "./PerfectArchiving.vue?vue&type=template&id=2a12cf8c&scoped=true&"
import script from "./PerfectArchiving.vue?vue&type=script&lang=js&"
export * from "./PerfectArchiving.vue?vue&type=script&lang=js&"
import style0 from "./PerfectArchiving.vue?vue&type=style&index=0&id=2a12cf8c&lang=scss&scoped=true&"
import style1 from "./PerfectArchiving.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12cf8c",
  null
  
)

export default component.exports